import {McpBillingComponent} from './service/mcp-billing.component';
import { McpProviderConnectionComponent } from './service/mcp-provider-connection.component';
import { mcpSupportChatEnabled } from './service/mcp-embed-presentation';
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule } from "@angular/forms";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { AngularWebStorageModule } from "angular-web-storage";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ModalModule } from "ngx-bootstrap/modal";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { HttpRequestInterceptor } from "./interceptors/http.interceptor";
import { ApiWriteInterceptor } from "./service/api-write.interceptor";
// import { MDBBootstrapModule } from "angular-bootstrap-md";
import { LayoutRequest } from "./util/static-data";
import { MangoMirrorConstants } from "./util/constants";
import { IntercomModule } from "@supy-io/ngx-intercom";
import { DatePipe } from "@angular/common";
import { NgxSpinnerModule } from "ngx-spinner";
import { ConfirmDialogComponent } from "./shared/dialog/confirm-dialog.component";
import { ToastrModule } from "ngx-toastr";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    McpBillingComponent,
    McpProviderConnectionComponent,
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    // MDBBootstrapModule.forRoot(),
    AngularWebStorageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxSpinnerModule.forRoot(),
    // WebBluetoothModule.forRoot({
    //   enableTracing: true, // or false, this will enable logs in the browser's console
    // }),
    ModalModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
      progressBar: true,
    }),
    ConfirmDialogComponent,
    IntercomModule.forRoot({
      appId: "r0j2hyik", // from your Intercom config
      updateOnRouterChange: mcpSupportChatEnabled(),
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiWriteInterceptor,
      multi: true,
    },
    DatePipe,
    LayoutRequest,
    MangoMirrorConstants,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
